var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#118f84",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480,64H193.16l-1.184-33.141C191.367,13.641,177.227,0,160,0H96C78.773,0,64.633,13.641,64.023,30.859L62.84,64H32 C14.328,64,0,78.328,0,96v32c0,17.672,14.328,32,32,32h27.411L48.986,451.904C38.924,457.297,32,467.785,32,480 c0,17.672,14.328,32,32,32h16h96h16c17.672,0,32-14.328,32-32c0-12.215-6.924-22.703-16.986-28.096L196.589,160H368v32.969 c0,3.516-1.578,6.391-3.094,7.133C337.211,213.633,320,241.18,320,272c0,43.367,36.633,80,80,80c44.109,0,80-35.891,80-80 c0-17.672-14.328-32-32-32s-32,14.328-32,32c0,8.82-7.18,16-16,16c-8.227,0-16-7.773-16-16c0-7.375,4.648-12.273,9.008-14.398 C416.695,246.016,432,220.648,432,192.969V160h48c17.672,0,32-14.328,32-32V96C512,78.328,497.672,64,480,64z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.d62e094788759df6486fe784ae16aa56.svg";
export { ForwardRef as ReactComponent };